<template>
  <div class="page-auth">
    <div class="w-100 h-100 overflow-auto">
      <div class="row m-0">
        <div class="col-10 col-sm-8 col-md-6 col-lg-4 mx-auto login-form">
          <div class="login-form-body rounded">
            <div
              class="d-flex justify-content-center align-items-center w-100 pb-4"
            >
              <img
                src="@/assets/pckk-logo.png"
                class="rounded"
                width="80"
                height="80"
              />
              <!-- <p class="mb-0 mr-2 font-weight-bold text-light">LOGIN</p> -->
            </div>
            <div class="input-group mb-3">
              <div class="input-group-prepend">
                <div
                  class="input-group-text rounded-left bg-white border-right-0 pr-3"
                  :class="{ 'border-danger': errors.identifier }"
                >
                  <font-awesome-icon :icon="['fas', 'at']" />
                </div>
              </div>
              <input
                type="text"
                class="form-control border-left-0 rounded-right"
                :class="{ 'border-danger': errors.identifier }"
                placeholder="Email"
                @keydown.enter="login()"
                v-model="models.identifier"
              />
            </div>
            <div class="input-group mb-4">
              <div class="input-group-prepend">
                <div
                  class="input-group-text rounded-left bg-white border-right-0 pr-3"
                  :class="{ 'border-danger': errors.password }"
                >
                  <font-awesome-icon :icon="['fas', 'lock-open']" />
                </div>
              </div>
              <input
                type="password"
                class="form-control border-left-0 rounded-right"
                :class="{ 'border-danger': errors.password }"
                placeholder="Password"
                @keydown.enter="login()"
                v-model="models.password"
              />
            </div>
            <small class="small text-danger text-center" v-if="loginError">
              Invalid email/password
            </small>
            <button
              class="btn btn-block btn-login btn-primary rounded"
              @click="login()"
              :disabled="isProcessing"
            >
              <span>Login</span>
              <div
                class="spinner-border spinner-border-sm text-light"
                v-if="isProcessing"
              ></div>
            </button>
            <button
              type="button"
              class="btn btn-sm btn-link w-100 mt-3"
              @click="goTo('Forget')"
            >
              <small>Forgot your password?</small>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import API from "@/api";
import Swal from "sweetalert2";

export default {
  name: "auth",
  data() {
    return {
      isProcessing: false,
      loginError: false,
      models: {
        identifier: "",
        password: "",
      },
      errors: {
        identifier: false,
        password: false,
      },
    };
  },
  methods: {
    login() {
      this.isProcessing = true;
      const hasError = this.verifyForm();
      if (!hasError) {
        API.post("auth/local", this.models)
          .then((retVal) => {
            delete retVal.data.user.cases;
            delete retVal.data.user.comments;

            localStorage.setItem("user", JSON.stringify(retVal.data.user));
            localStorage.setItem("token", retVal.data.jwt);

            this.$nextTick(() => {
              let nextPage =
                retVal.data.user.role.name == "JKR District"
                  ? "tenders"
                  : "landing";

              this.$router.push({
                name: nextPage,
              });
            });

            this.isProcessing = false;
          })
          .catch((err) => {
            console.error(err);

            this.isProcessing = false;

            Swal.fire({
              icon: "error",
              title: err || "Invalid email or password",
            });
          });
      } else {
        this.isProcessing = false;
      }
    },
    verifyForm() {
      this.loginError = false;
      for (let index = 0; index < Object.keys(this.models).length; index++) {
        const key = Object.keys(this.models)[index];
        const model = this.models[key];

        if (!model) {
          this.errors[key] = true;
          this.loginError = true;
        } else {
          this.errors[key] = false;
        }
      }
      return this.loginError;
    },
    goTo(name) {
      this.$router.push({
        name: name,
      });
    },
  },
};
</script>
